// src/api/countryService.js
import api, { publicApi } from "./api";

/* =========================
   GET ALL COUNTRIES (PUBLIC)
   GET /api/country
   ========================= */
export const getCountries = async () => {
    const res = await publicApi.get("/country");
    return res.data;
};

/* =========================
   GET COUNTRY BY ID (PUBLIC)
   GET /api/country/{id}
   ========================= */
export const getCountryById = async (id) => {
    const res = await publicApi.get(`/country/${id}`);
    return res.data;
};

/* =========================
   CREATE COUNTRY (ADMIN)
   POST /api/country
   ========================= */
export const createCountry = async (data) => {
    const res = await api.post("/country", data);
    return res.data;
};

/* =========================
   UPDATE COUNTRY (ADMIN)
   PUT /api/country/{id}
   ========================= */
export const updateCountry = async (id, data) => {
    const res = await api.put(`/country/${id}`, data);
    return res.data;
};

/* =========================
   DELETE COUNTRY (ADMIN)
   DELETE /api/country/{id}
   ========================= */
export const deleteCountry = async (id) => {
    const res = await api.delete(`/country/${id}`);
    return res.data;
};